module.exports = __webpack_public_path__ + "static/img/wanted5.f6c6e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/wanted5.png
// module id = wPms
// module chunks = 1 3